import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "../css/landingPage.css";
import cst from "../images/partnerLogos/cst.png";
import kenli from "../images/partnerLogos/kenli.png";
import kmc from "../images/partnerLogos/kmc.png";
import maxxis from "../images/partnerLogos/maxxis.png";
import wtb from "../images/partnerLogos/wtb.png";
import schwalbe from "../images/partnerLogos/schwalbe.png";
import neco from "../images/partnerLogos/neco.png";
import ralson from "../images/partnerLogos/ralson.png";
import prowheel from "../images/partnerLogos/prowheel.png";
import sunrace from "../images/partnerLogos/sunrace.png";
import shimano from "../images/partnerLogos/shimano.png";
import sram from "../images/partnerLogos/sram.png";
import rockshox from "../images/partnerLogos/rockshox.png";
import microshift from "../images/partnerLogos/microshift.png";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import Meta from "../components/Meta";
import Modal from "../components/Modal";
import ModalMobile from "../components/ModalMobile";
import ReactPlayer from "react-player";
import CustomBike from "../components/CustomBike";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";
import "../css/navbar.css";
import logo from "../images/brandLogos/Dynem red white.png";
import { Icon } from "@iconify/react";
import ReCAPTCHA from "react-google-recaptcha";
import "../css/landingPage2.css";

const LandingPage2Fr = () => {
  const [capVal, setCapVal] = useState("");

  const featuresData = [
    {
      key: "precisionControllers",
      heading: "Contrôleurs de précision",
      description:
        "Les contrôleurs de vélos électriques utilisent des capteurs intelligents et des algorithmes pour fournir la puissance en douceur, améliorer les performances et rendre les trajets plus intuitifs. Construisez plus intelligemment avec les composants DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Controlerrrr.png",
    },
    {
      key: "highPerformanceChargers",
      heading: "Chargeurs haute performance",
      description:
        "Nos chargeurs sont disponibles en options personnalisables – conçus pour une compatibilité mondiale, une portabilité facile et des besoins en énergie flexibles. Donnez de l’énergie à votre marque avec DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Chargerrrr.png",
    },
    {
      key: "multifunctionalDisplays",
      heading: "Écran multifonction",
      description:
        "Les écrans LCD multifonctions affichent en temps réel des données telles que la vitesse et le niveau de batterie, aidant les cyclistes à garder le contrôle et à changer de mode facilement. Améliorez la technologie de votre trajet avec DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Displayyyyy.png",
    },
    {
      key: "longLastingBatteries",
      heading: "Batteries longue durée",
      description:
        "Nos batteries longue durée sont conçues pour des performances constantes, une durée de vie prolongée et une alimentation optimale – alimentant chaque trajet avec fiabilité. Énergisez vos vélos électriques avec DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Baterryyyyy.png",
    },
    {
      key: "efficientMotors",
      heading: "Efficient Motors",
      description:
        "Nos moteurs efficaces offrent des performances fiables et précises dans toutes les applications – conçus pour la puissance, conçus pour un objectif. Stimulez votre innovation avec DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/motorrrr.png",
    },
  ];
  const [open, openNav] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  const closeNavforDeadLink = () => {
    openNav(false);
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [sales, setSales] = useState("");
  const [productPortfolio, setProductPortfolio] = useState("");

  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Enter Contact Number");
      return;
    }
    const response = await fetch("/api/verify-captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ capVal }),
    });

    const dataCaptcha = await response.json();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const reqBody = {
      name,
      email,
      phoneNumber,
      companyName,
      enquiry,
      country,
      sales,
      productPortfolio,
    };
    if (dataCaptcha) {
      const { data } = await axios.post(
        "/api/form/request-a-quote",
        reqBody,
        config
      );
      if (data) {
        navigate("/details-submitted");
      }
    } else {
      alert("CAPTCHA Verification Failed!");
    }
  };
  return (
    <>
      <div
        className="position-fixed w-100 d-lg-none"
        style={{ bottom: "1.5%", zIndex: 2 }}
      >
        <div className="d-flex justify-content-center">
          <Link
            to={"/landing-page/form"}
            style={{ width: "85%" }}
            className="btn btn-danger py-2 rounded-5"
          >
            Get in Touch
          </Link>
        </div>
      </div>

      <div id="LandingPage2">
        {/* hero-section */}
        <div className="position-relative">
          <div
            className="position-absolute w-100"
            style={{ top: "2%", zIndex: "1" }}
          >
            <div className="d-lg-block d-none">
              <div className="d-flex justify-content-between align-items-center px-lg-5 mb-5">
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <Link
                  to={"/"}
                  className="btn btn-danger fw-bold px-4 py-2 rounded-5"
                  style={{ backgroundColor: "#ff0000" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Get in Touch
                </Link>
              </div>
              <div>
                <h3 className="poppins-bold mb-3 text-center text-uppercase text-light">
                  South East Asia’s Largest E-Bike Manufacturer & Exporter
                </h3>
                <h5 className="text-light text-center poppins-medium">
                  Building the Future of Mobility
                </h5>
              </div>
            </div>

            <div className="d-lg-none">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "2em", flexDirection: "column" }}
              >
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <div>
                  <h5 className="poppins-bold mb-3 text-center text-uppercase text-light">
                    South East Asia’s Largest E-Bike Manufacturer & Exporter
                  </h5>
                  <p className="text-light text-center poppins-medium">
                    Building the Future of Mobility
                  </p>
                </div>
              </div>
            </div>
          </div>
          <video
            className="w-100"
            autoPlay
            loop
            muted
            playsInline
            style={{ height: "100vh", width: "100vw", objectFit: "cover" }}
          >
            <source
              media="(max-width:650px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+page+video+phone+view+.mp4"
              type="video/mp4"
            />
            <source
              media="(min-width:651px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+Page+video+desktop+view+.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div
            className="position-absolute d-lg-block d-none w-100"
            style={{ bottom: "8%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-5"
              style={{ gap: "12em" }}
            >
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">
                  240,000 sq. ft.
                </h4>
                <h5 className="poppins-bold text-light mb-3">Gigafactory</h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">500,000</h4>
                <h5 className="poppins-bold text-light mb-3">
                  E-Bikes Yearly Production Capacity
                </h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">18+</h4>
                <h5 className="poppins-bold text-light mb-3">Countries </h5>
              </div>
            </div>
          </div>
          <div
            className="position-absolute d-lg-none text-light"
            style={{ bottom: "13%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-3"
              style={{ gap: "0.9em" }}
            >
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  240,000 sq. ft.
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Gigafactory
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  500,000
                </p>
                <p
                  className="poppins-bold text-light mb-1 w-75 mx-auto"
                  style={{ fontSize: "0.6em" }}
                >
                  E-Bikes Yearly Production Capacity
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  18+
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Countries{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* form */}
        <div className="d-none d-lg-block my-5 py-lg-5 container">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            LConstruisons votre prochaine grande aventure
          </h2>
          <div className="d-flex justify-content-center mb-4">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Connectez-vous avec notre équipe de développement commercial pour
              explorer comment DYNEM peut alimenter votre vision des vélos
              électriques.
            </h5>
          </div>
          <div className="row p-0">
            <div className="col-6 p-3">
              <h3 className="poppins-medium mb-4">Pourquoi choisir DYNEM?</h3>
              <div>
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Group+49.jpg"
                  className="img-fluid"
                ></img>
              </div>
            </div>
            <div className="col-6 p-3">
              <form className="" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Nom*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control text-dark"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Téléphone*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Email*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1 text-light"
                      style={{ fontSize: "0.8em" }}
                      className="form-label"
                    >
                      Entreprise*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Operational Countries*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Post Your Enquiry*
                  </label>
                  <textarea
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    class="form-control rounded-0"
                    required
                    id="exampleFormControlTextarea1"
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  style={{ backgroundColor: "#ff0000" }}
                  class="btn btn-danger w-100 poppins-medium rounded-5 py-2"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* ebikes */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Du concept au trajet – Votre partenaire OEM pour chaque étape
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Que vous lanciez un vélo urbain ou une machine tout-terrain
              puissante, DYNEM a la technologie, le design et la puissance pour
              le réaliser.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Mountain+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Vélos électriques de montagne
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Nous ne faisons pas que construire des vélos électriques
                      de montagne — nous concevons des machines prêtes pour
                      l'aventure. Conçue pour les terrains accidentés, notre
                      gamme tout-terrain offre une puissance, un contrôle et des
                      performances inégalés. Affrontez la nature de front avec
                      DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Foldable+Fat+tyre.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Vélos électriques pliables à pneus larges
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Compacts quand vous en avez besoin. Robustes quand c'est
                      important. Nos vélos électriques pliables à pneus larges
                      sont conçus pour une vie en mouvement — parfaits pour les
                      trajets en ville, les voyages et les escapades du
                      week-end. Trouvez votre liberté pliable avec DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/City+Bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Vélos électriques de ville
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Glissez dans la circulation avec facilité. Nos vélos
                      électriques de ville allient technologie de pointe et
                      design moderne pour rendre les trajets quotidiens sans
                      effort, confortables et élégants. Redéfinissez votre
                      trajet urbain avec DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Delivery+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Vélos électriques de livraison
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Conçus pour les entreprises en déplacement. Ces vélos
                      électriques sont conçus pour des livraisons intensives
                      avec des cadres durables, un espace de chargement de
                      grande capacité et des performances fiables — tout en
                      restant écologiques. Gardez vos opérations rapides,
                      intelligentes et durables avec DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        {/* components */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Alimenter le cœur de chaque vélo électrique
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Qu'il s'agisse d’un moteur à couple élevé ou d’un écran numérique
              élégant, DYNEM fournit la précision, la performance et la
              fiabilité pour alimenter votre trajet avec des composants de
              qualité.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              {featuresData.map((feature, index) => (
                <SplideSlide className="h-100 p-2">
                  <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                    <div className="text-start col col-md-6 p-lg-3 d-lg-block d-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="ecycle-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                    <div className="col col-md-6">
                      <img src={feature.image} alt="" className="w-75" />
                    </div>
                    <div className="text-start col col-md-6 p-lg-3 d-lg-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="component-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
        {/* breaker */}
        <div className="mt-5 py-lg-5">
          <picture className="">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/phone+anti+Dumping+banner.png.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
              alt="assurance"
              className="d-block img-fluid"
            />
          </picture>
        </div>
        {/* trust section */}
        <div className="container mt-5 py-4 py-lg-5 trust-section-landing-page2">
          <h2 className="poppins-bold mb-2 text-uppercase text-center">
            Pourquoi les marques mondiales font confiance à DYNEM
          </h2>
          <h5 className="text-center mb-0 text-muted">
            Votre produit. Notre expertise.
          </h5>
          <div className="mt-5 pt-lg-3">
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/end-to-end.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Partenaire de fabrication de bout en bout
              </h4>
              <div className="col-md-6">
                <small>
                  Du concept à la livraison finale, nous offrons des solutions
                  OEM et en marque blanche complètes, adaptées aux besoins de
                  votre marque.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/stae-of-art.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Fabrication à la pointe de la technologie
              </h4>
              <div className="col-md-6">
                <small>
                  Des lignes de production automatisées et une ingénierie de
                  précision garantissent une qualité de fabrication constante à
                  grande échelle, répondant aux normes internationales.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/high-performance.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Technologie haute performance
              </h4>
              <div className="col-md-6">
                <small>
                  Nous intégrons des moteurs puissants, des batteries longue
                  portée et des systèmes IoT intelligents pour livrer des vélos
                  électriques adaptés aux besoins de mobilité moderne.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/e-cycles.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                500 000+ vélos électriques par an
              </h4>
              <div className="col-md-6">
                <small>
                  Notre infrastructure évolutive prend en charge tout, des
                  petites séries personnalisées à la production mondiale à grand
                  volume avec rapidité et précision.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/components.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                4 millions+ de composants par an
              </h4>
              <div className="col-md-6">
                <small>
                  Avec un approvisionnement à grande capacité et une intégration
                  en interne, nous assurons disponibilité, efficacité et qualité
                  sur tous les composants.
                </small>
              </div>
            </div>
          </div>
        </div>
        {/* company logos */}
        <div className="logos-landing-page2">
          <h3 className="poppins-bold mb-0 text-center text-uppercase">
            Le nom sur lequel les marques mondiales comptent
          </h3>
          <div className="container my-lg-5 pb-5 d-none d-lg-block">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
          <div className="my-5 d-lg-none">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        <div className="my-5 py-lg-5 container">
          <Splide
            className="mb-2 mb-lg-0 p-0 align-items-center text-center"
            options={{
              arrows: true,
              start: 0,
              drag: false,
              type: "loop",
              pagination: true,
              autoplay: true,
              gap: "1em",
              padding: "1em",
              pauseOnHover: false,
              resetProgress: false,
              perPage: 3,
              perMove: 1,
              speed: 1000,
              interval: 4000,
              breakpoints: {
                700: {
                  drag: true,
                  autoplay: false,
                  pagination: "false",
                  perPage: 1,
                  perMove: 1,
                  gap: "2em",
                  padding: "0em",
                  arrows: false,
                  pauseOnHover: false,
                  resetProgress: false,
                },
              },
            }}
          >
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “DYNEM n’a pas seulement fourni des composants – ils ont
                      compris notre vision produit et nous ont aidés à la
                      concrétiser. Leur équipe ressemble davantage à une
                      extension de la nôtre.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Responsable Produit, Startup de vélos électriques
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Nous sommes passés de 500 à 5 000 unités par mois sans
                      aucun problème. La régularité de DYNEM en matière de
                      qualité et de délais a tout changé.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– COO, Marque de mobilité en Asie du Sud-Est</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Grâce aux exportations conformes aux règles antidumping
                      de DYNEM, nous avons pénétré le marché de l’UE avec
                      d’énormes économies sur les droits de douane — des coûts
                      réduits de presque 87 %.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Directeur du commerce international, détaillant basé aux
                      États-Unis
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Des moteurs haute efficacité aux cadres robustes, chaque
                      composant que nous obtenons de DYNEM offre performance et
                      durabilité.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– CTO, Marque de vélos électriques d’aventure</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “La flexibilité pour personnaliser notre gamme de vélos
                      pliants a été vraiment incroyable. DYNEM nous a donné la
                      liberté de créer un produit qui reflète notre marque.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– Chef de produit, Marque de mobilité urbaine</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Ils ne se contentent pas de fabriquer – ils résolvent des
                      problèmes. DYNEM nous a aidés à repenser des pièces clés
                      qui ont réellement amélioré les performances de nos
                      trajets.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Responsable R&D, Marque haut de gamme de vélos
                      électriques
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
          </Splide>
        </div>
        {/* news */}
        <div className="news">
          <div className="container mt-5 py-4 py-lg-5">
            <h2 className="poppins-bold text-uppercase mb-3 mb-lg-5">
              Dans l'actualité
            </h2>
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center"
              options={{
                arrows: false,
                drag: false,
                type: "slide",
                pagination: false,
                autoplay: false,
                perMove: 1,
                gap: "1em",
                padding: "0em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 4,
                speed: 1000,
                interval: 3000,
                breakpoints: {
                  700: {
                    drag: true,
                    perPage: 1.3,
                    arrows: false,
                    perMove: 1,
                    gap: "1em",
                    padding: "0em",
                    pauseOnHover: false,
                    resetProgress: false,
                    focus: 0,
                    start: 0,
                    speed: 1000,
                    interval: 3000,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+1.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/kxan.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM begins construction of World's Biggest Integrated
                    Electric Cycle Gigafactory.....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.kxan.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/ktla.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    India’s DYNEM to Establish World’s Largest Integrated E-Bike
                    Gigafactory
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://fox59.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/benzinga.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Breaks Ground on World’s Largest Integrated Electric
                    Cycle Gigafactory ...
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+4.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/fox8.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Strengthens India’s Manufacturing Prowess: World’s
                    Biggest .....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
            <div className="mt-5 pt-lg-4">
              <h2 className="poppins-medium mb-3 mb-lg-4 container">
                Certifications
              </h2>
              <div className="container pb-4">
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/certifications__png.png"
                  alt="certifications"
                  className="w-100"
                ></img>
              </div>
            </div>
          </div>
        </div>
        {/* FAQs */}
        <div className="container mt-5 pt-lg-5">
          <div className="d-flex faq-landing">
            <div className="faq-landing-1">
              <h2 className="poppins-medium mb-2 mb-lg-4">
                Questions fréquemment posées
              </h2>
              <p className="mb-lg-5">
                Vous avez des questions ? Nous avons déjà des réponses. C’est
                comme si nous pouvions vous entendre réfléchir.
              </p>
              <div className="d-lg-block d-none">
                <h4 className="poppins-medium mb-2">
                  Avons-nous raté quelque chose?
                </h4>
                <p className="mb-lg-5">
                  Participez à un appel individuel avec nos experts.
                </p>
                <div className="req-call my-5 my-lg-0">
                  <a
                    href="tel:+918956703515"
                    className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                    style={{ width: "fit-content" }}
                  >
                    Demander un appel
                  </a>
                </div>
              </div>
            </div>
            <div className="accordion faq-landing-2" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Qu'est-ce qui différencie DYNEM des autres fabricants de
                    vélos électriques?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body poppins-thin">
                    <p>
                      DYNEM se démarque par son innovation de pointe, ses
                      pratiques respectueuses de l'environnement et ses
                      nombreuses options de personnalisation. Notre gigafactory
                      de pointe, notre conformité mondiale et notre équipe
                      d'experts garantissent une qualité de premier ordre et un
                      support transparent de la production à l'après-vente, vous
                      laissant l'esprit tranquille.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Puis-je personnaliser mon vélo électrique avec DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Absolument! DYNEM propose de nombreuses options de
                      personnalisation, vous permettant d'adapter votre vélo
                      électrique à votre style et à vos besoins spécifiques.
                      Notre service OEM vous permet de personnaliser la marque,
                      les spécifications et les fonctionnalités en fonction de
                      vos préférences.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Combien de vélos électriques DYNEM produit-il chaque année?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM a la capacité de produire et de personnaliser 500
                      000 vélos électriques par an. Nos processus de production
                      efficaces et notre infrastructure de classe mondiale nous
                      permettent de répondre à la demande mondiale croissante.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Quels sont les avantages des solutions antidumping de DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Les solutions antidumping légales de DYNEM permettent aux
                      importateurs d'économiser jusqu'à 87% de taxes. Nos
                      produits sont conformes aux réglementations mondiales,
                      garantissant des règles du jeu équitables sans aucune taxe
                      antidumping. Cela fait de DYNEM un choix rentable et
                      conforme pour les importateurs du monde entier.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Comment DYNEM soutient-il la durabilité?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM s'engage en faveur de la durabilité grâce à des
                      pratiques respectueuses de l'environnement et une
                      technologie innovante. Nos vélos électriques sont conçus
                      pour réduire l'empreinte carbone et promouvoir un avenir
                      plus vert, conformément à notre vision de la mobilité
                      durable.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    Quel type de support après-vente DYNEM propose-t-il?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      <Link
                        to={"/"}
                        style={{ color: "inherit", cursor: "auto" }}
                        className="text-decoration-none"
                      >
                        DYNEM
                      </Link>{" "}
                      donne la priorité à la satisfaction de ses clients avec un
                      support après-vente dédié. De l'achat initial à la
                      maintenance à long terme, notre équipe s'engage à fournir
                      une assistance transparente et fiable, garantissant une
                      expérience fluide et satisfaisante à nos clients
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-none text-center mt-3">
              <h4 className="poppins-medium mb-2">
                Avons-nous raté quelque chose?
              </h4>
              <p className="mb-lg-5">
                Participez à un appel individuel avec nos experts.
              </p>
              <div className="req-call my-4">
                <a
                  href="tel:+918956703515"
                  className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                  style={{ width: "fit-content" }}
                >
                  Demander un appel
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="d-lg-block d-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <Modal className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        <div className="d-lg-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <ModalMobile className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        {/* contact us */}
        <div className="mt-5 py-lg-5" style={{ backgroundColor: "black" }}>
          <div className="container py-lg-5 py-4">
            <div className="d-flex mb-3 mb-lg-0" style={{ gap: "4em" }}>
              <div className="d-none d-lg-block w-50">
                <div className="row">
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-start mt-5">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-start">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block">
                <h2 className="poppins-bold mb-4 text-light">
                  Connectons-nous
                </h2>
                <form className="contact-us-landing" onSubmit={submit}>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-100">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Nom*
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div class="w-50">
                      <label
                        for="exampleInputPassword1"
                        class="form-label text-light"
                      >
                        Téléphone*
                      </label>
                      <IntlTelInput
                        onChangeNumber={setPhoneNumber}
                        initOptions={{
                          initialCountry: "auto",
                          geoIpLookup: function (success, failure) {
                            fetch("https://ipapi.co/json")
                              .then((res) => res.json())
                              .then((data) => success(data.country_code))
                              .catch(() => failure());
                          },
                          strictMode: true,
                          separateDialCode: true,
                        }}
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Work Email*
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1 text-light"
                        className="form-label text-light"
                      >
                        Entreprise*
                      </label>
                      <input
                        type="text"
                        value={companyName}
                        required
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Product Portfolio*
                      </label>
                      <select
                        onChange={(e) => setProductPortfolio(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="E-Bikes">E-Bikes</option>
                        <option value="E-Scooters">E-Scooters</option>
                        <option value="Hyper-Bikes">Hyper-Bikes</option>
                        <option value="Moped">Moped</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Operational Countries*
                      </label>
                      <input
                        type="text"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Annual E-Bike Sales (units)
                      </label>
                      <select
                        onChange={(e) => setSales(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="less than 1000 units">
                          less than 1000 units
                        </option>
                        <option value="1000-5000 units">1000-5000 units</option>
                        <option value="5000-50,000 units">
                          5000-50,000 units
                        </option>
                        <option value="50,000+ units">50,000+ units</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Post Your Enquiry*
                    </label>
                    <textarea
                      class="form-control rounded-0"
                      required
                      id="exampleFormControlTextarea1"
                      rows="3"
                      value={enquiry}
                      onChange={(e) => {
                        setEnquiry(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  <div className="mb-3 d-flex justify-content-center">
                    <ReCAPTCHA
                      sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                      onChange={(val) => setCapVal(val)}
                    ></ReCAPTCHA>
                  </div>
                  <button
                    disabled={!capVal}
                    type="submit"
                    class="btn btn-light w-100 poppins-medium rounded-0"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
            <div className="d-lg-none mb-5">
              <h2 className="poppins-bold mb-4 text-light">Connectons-nous</h2>
              <form className="contact-us-landing" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Nom*
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label text-light"
                    >
                      Téléphone*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Work Email*
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Entreprise*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Operational Countries*
                    </label>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label text-light"
                  >
                    Post Your Enquiry*
                  </label>
                  <textarea
                    class="form-control rounded-0"
                    id="exampleFormControlTextarea1"
                    required
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  class="btn btn-light w-100 poppins-medium rounded-0"
                >
                  Submit
                </button>
              </form>
            </div>
            <div className="row p-2 d-lg-none">
              <div className="col-6 p-0">
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                    className="w-75 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
              </div>
              <div className="col-6 p-0">
                <div className="d-flex justify-content-start mt-5">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-start">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                    className="w-75 p-2"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage2Fr;
